<script setup lang="ts">
withDefaults(defineProps<{
  as?: string
  padded?: boolean
}>(), {
  as: 'section',
  padded: true,
})
</script>

<template>
  <component
    :is="as"
    class="bg-brand-chalk text-brand-ink relative overflow-hidden"
    :class="padded ? 'px-6 py-14 sm:px-10 sm:py-20' : ''"
  >
    <SfgSurfaceTexture variant="chalk"/>
    <div class="relative z-10">
      <slot/>
    </div>
  </component>
</template>
